module.exports = __webpack_public_path__ + "static/media/CheckCircleCorrect.f78ae393.svg";